import Container from 'components/Container'
import styled from 'react-emotion'
import { spacer } from 'stylist'

const PageContainer = styled(Container)`
  grid-template-columns: 160px 1fr;
  grid-template-rows: auto 1fr;
  grid-gap: ${spacer(5)};
  margin: 0 auto;
  padding-top: ${spacer(6)};
  padding-bottom: ${spacer(6)};
  height: 100%;
`

export default PageContainer



// WEBPACK FOOTER //
// ./src/components/Sidebar/PageContainer.js